// Verbatim WebOrion Enterprise SaaS Terms of Service (v2024.7.26).
// <u>...</u> marks the words that are underlined in the source PDF (rendered by TermsOfService.vue).
export const TERMS_OF_SERVICE_BLOCKS = [
  {
    "type": "title",
    "text": "TERMS OF SERVICE"
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "These Terms of Service (together with the other documents expressly referred to in it) (“Terms”) contains the terms and conditions on which the WebOrion Enterprise Software-as-a-Service (the “Service”) is offered to you."
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "Please read the Terms carefully and ensure that you understand them before subscribing to the Service. Please note that by subscribing to the Service, you agree to be bound by the Terms and the other documents expressly referred to in it. You should print a copy of the Terms for future reference."
  },
  {
    "type": "heading",
    "text": "1. INFORMATION ABOUT US"
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "The Service is offered by Cloudsine Pte Ltd (Registration No. 201221195G) (“us”, “our” or “we”), a Singapore registered company with a place of business at 83 Science Park Drive, #02-01C, The Curie, Singapore 118258. Contact information can be found on our website at https://www.cloudsine.tech/."
  },
  {
    "type": "heading",
    "text": "2. OUR OBLIGATIONS"
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "We shall perform the Service with reasonable skill and care, and shall use commercially reasonable efforts to make the Service available twenty four (24) hours a day, seven (7) days a week with an uptime of ninety nine point nine percent (99.9%) per year (the “Service Level”). Notwithstanding the foregoing, we do not warrant that the Service will be uninterrupted or error-free, and we shall not be responsible for any loss or damage (including any indirect, special, incidental or consequential loss or damage) arising from or relating to an interruption of or an error in the Service for any reason. In addition, where necessary, we may have <u>either</u> up to four (4) hours of scheduled minor maintenance per month <u>or</u> up to eight (8) hours of scheduled major maintenance every two (2) months. For the avoidance of doubt, the calculation of down time shall not include any scheduled maintenance."
  },
  {
    "type": "heading",
    "text": "3. YOUR OBLIGATIONS"
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "You agree to comply with all applicable laws and regulations with respect to your activities under these Terms; and obtain and maintain all necessary licences, consents and permissions necessary for us, our officers, employees, representatives, contractors and agents to perform our/their obligations under these Terms, including without limitation obtaining the prior consent of the owner(s) of the URL(s) and/or IP address(es) monitored using the Service."
  },
  {
    "type": "heading",
    "text": "4. CHARGES AND PAYMENT"
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "The applicable subscription fees are set out in our official quotation to you. Subscriptions can only be made by raising a Purchase Order. All payments are to be made in advance, and, subject to clause 8.3, payment once paid is non-refundable. Future subscription fees may change from time to time. Subscription fees include Goods and Services Tax (where applicable) at the applicable current rate chargeable in Singapore for the time being."
  },
  {
    "type": "heading",
    "text": "5. PROPRIETARY RIGHTS"
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "5.1 You acknowledge and agree that we and/or our licensors are the owners of all intellectual property rights in the Service. Except as expressly stated herein, these Terms do not grant you any rights to, or in, patents, copyrights, database rights, trade secrets, trade names, trademarks (whether registered or unregistered), or any other rights or licences in respect of the Service."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "5.2 Unless you notify us otherwise in writing, you agree that during and after the term of Service we may use your trade name, trademark or logo solely for the purposes for identifying you as a current or past user of our Service."
  },
  {
    "type": "heading",
    "text": "6. INDEMNITY"
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "6.1 You agree to defend and indemnify us and hold us harmless against claims, actions, proceedings, losses, damages, expenses and costs (including without limitation court costs and reasonable legal fees) arising out of or in connection with your use of the Service where such loss, damage, expense or cost is not due to our gross negligence or willful default."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "6.2 Subject to clause 7.4, other than for interruptions of or errors in the Service due to our failure to meet the Service Level arising from causes within our control, we agree to defend and indemnify you and hold you harmless against claims, actions, proceedings, losses, damages, expenses and costs (including without limitation court costs and reasonable legal fees) arising out of or in connection with our provision of the Service where such loss, damage, expense or cost is due to our gross negligence or willful default."
  },
  {
    "type": "heading",
    "text": "7. LIMITATION OF LIABILITY"
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "7.1 Nothing in these Terms excludes our liability for death or personal injury caused by our negligence, or for fraud or fraudulent misrepresentation."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "7.2 To the furthest extent permitted by law, we exclude all conditions, warranties, representations or other terms, express or implied, including, but not limited to, warranties of fitness for purpose or merchantability, or freedom from infringement of any patent or any other rights of any third parties with respect to the Service, unless expressly included in these Terms."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "7.3 Subject to clause 7.1, we shall not be liable for loss of profits, sales or business revenue, business interruption, loss of business opportunity, goodwill or reputation, or any indirect or consequential loss or damage."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "7.4 If you have subscribed to the Service, subject to clause 7.1, you agree that your sole and exclusive remedy in the event of any interruptions of or errors in the Service due to our failure to meet the Service Level and regardless of the number of occurrences of such interruptions or errors during the term of your subscription (including any extensions which you opt for), shall be up to one (1)-month extension of the current subscription term free of charge. However, we shall not be liable for any interruptions of or errors in the Service due to reasons beyond our control."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "7.5 If you have signed up for a free trial of the Service, subject to clause 7.1, we shall not be liable for any interruptions of or errors in the Service for any reason."
  },
  {
    "type": "heading",
    "text": "8. TERM AND TERMINATION"
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "8.1 These Terms shall commence on the date on which you accept these Terms, and shall continue:"
  },
  {
    "type": "paragraph",
    "indent": 2,
    "text": "8.1.1 if you have signed up for a free trial of the Service, for a period of fourteen (14) days; or"
  },
  {
    "type": "paragraph",
    "indent": 2,
    "text": "8.1.2 if you have subscribed to the Service, for a term equivalent to the subscription term which you have elected, which shall be at least twelve (12) months. You may opt to extend the subscription term at any time before expiry of the subscription term, and if so, any discounts on the subscription fee offered for extended subscriptions shall apply."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "8.2 You agree that we may terminate your access to the Service if any of the following circumstances occur:"
  },
  {
    "type": "paragraph",
    "indent": 2,
    "text": "8.2.1 we do not receive full payment for the Service;"
  },
  {
    "type": "paragraph",
    "indent": 2,
    "text": "8.2.2 discontinuance of the Service;"
  },
  {
    "type": "paragraph",
    "indent": 2,
    "text": "8.2.3 occurrence of unexpected technical issues or problems; or"
  },
  {
    "type": "paragraph",
    "indent": 2,
    "text": "8.2.4 where required by order of court or law enforcement, governmental, administrative or regulatory body."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "8.3 All payments for subscriptions are non-refundable."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "8.4 Termination of these Terms shall not affect any rights that you and we may have as at termination, or the continuation after termination of any provision expressly stated to survive or implicitly surviving termination."
  },
  {
    "type": "heading",
    "text": "9. RIGHT TO VARY THE TERMS"
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "9.1 We may revise the Terms from time to time."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "9.2 Whenever the terms are revised in accordance with clause 9.1, we will give you notice via email or by posting a notice of this on our website by stating that these Terms have been amended and the effective date of any such amendments."
  },
  {
    "type": "heading",
    "text": "10. EVENTS OUTSIDE OUR CONTROL"
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "10.1 We will not be liable or responsible for any failure to perform, or delay in performance of, any of our obligations under these Terms that is caused by an event outside our control (“Force Majeure Event”). A Force Majeure Event is defined below in clause 10.2."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "10.2 A Force Majeure Event means any act or event beyond our reasonable control, including without limitation strikes, lock-outs or other industrial action by third parties, civil commotion, riot, invasion, terrorist attack or threat of terrorist attack, war (whether declared or not) or threat or preparation for war, fire, explosion, storm, flood, earthquake, subsidence, epidemic or other natural disaster, or failure of public or private telecommunications networks."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "10.3 If a Force Majeure Event takes place that affects the performance of our obligations under these Terms, we will contact you as soon as reasonably possible to notify you; and such obligations will be suspended and the time for performance of the obligations will be extended for the duration of the Force Majeure Event."
  },
  {
    "type": "heading",
    "text": "11. WAIVER"
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "Any failure by us to insist that you perform any of your obligations under these Terms, or to enforce our rights against you, or delays in doing so, will not mean that we have waived our rights against you and will not mean that you do not have to comply with those obligations. If we do waive a default by you, we will only do so in writing, and that will not mean that we will automatically waive any later default by you."
  },
  {
    "type": "heading",
    "text": "12. SEVERANCE"
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "Each of the paragraphs of these Terms operates separately. If any court or relevant authority decides that any of them is unlawful or unenforceable, the remaining paragraphs will remain in full force and effect."
  },
  {
    "type": "heading",
    "text": "13. ENTIRE AGREEMENT"
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "These Terms, and any documents referred to in it, constitute the whole agreement between us and supersede any previous arrangement, understanding or agreement between us. Both you and we acknowledge and agree that in entering into these Terms, you and we do not rely on any undertaking, promise, assurance, statement, representation, warranty or understanding (whether in writing or not) of any person (whether party to these Terms or not) relating to the subject matter of these Terms, other than as expressly set out herein."
  },
  {
    "type": "heading",
    "text": "14. ASSIGNMENT"
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "We may transfer our rights and obligations under these Terms to another organisation and will notify you in writing on or before doing so. You may only transfer your rights or your obligations under these Terms to another person if we agree in writing."
  },
  {
    "type": "heading",
    "text": "15. THIRD PARTY RIGHTS"
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "These Terms are between the Parties. No other person shall have any rights to enforce any of these Terms, whether under the Contracts (Rights of Third Parties) Act (Cap 53B) or otherwise."
  },
  {
    "type": "heading",
    "text": "16. NOTICES"
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "16.1 Reference in these Terms to “in writing” shall include email."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "16.2 You may contact us at sales@cloudsine.tech."
  },
  {
    "type": "paragraph",
    "indent": 1,
    "text": "16.3 Please note that any notice given by you to us, or by us to you, will be deemed received and properly served immediately when posted on our website, or if sent by email, twenty (24) hours after an e-mail is sent. In proving the service of any notice, it will be sufficient to prove, in the case of an e-mail, that such e-mail was sent to the specified e-mail address of the addressee. The provisions of this clause shall not apply to the service of any proceedings or other documents in any legal action."
  },
  {
    "type": "heading",
    "text": "17. GOVERNING LAW AND JURISDICTION"
  },
  {
    "type": "paragraph",
    "indent": 0,
    "text": "These Terms are governed by Singapore law. Any dispute between us shall in the first instance be referred to our representatives for resolution. If such efforts fail, then the dispute shall be referred to binding arbitration in Singapore in accordance with the Arbitration Rules of the Singapore International Arbitration Centre in force at such time. The arbitration tribunal shall consist of one (1) arbitrator chosen by the Singapore International Arbitration Centre under its rules if we cannot otherwise agree upon an arbitrator."
  }
];
